import { RouteComponentProps, Router } from "@reach/router"
import { usePolicyAndFleet } from "../contexts"
import { AddToFleet } from "./add"
import { FleetList } from "./list"
import { usePolicyAccessCapabilities } from "../hooks/usePolicyAccessCapabilities"

export const FleetRouter: React.FC<RouteComponentProps> = () => {
  const { policy } = usePolicyAndFleet()
  const { policyHasAccessTo } = usePolicyAccessCapabilities()

  return (
    <Router>
      <FleetList path="fleet" default />
      {policy.status === `bound` && policyHasAccessTo(`ADD_VEHICLES`) && <AddToFleet path="add" />}
    </Router>
  )
}
